import { TextField } from 'react-admin';

const TextFieldA = (props: any) => (
  <TextField data-testid={props.source} {...props} />
);

export default TextFieldA;
